module.exports = __webpack_public_path__ + "img/7_Seller Signed a contract.f5d35083.svg";